import apiClient from "./apiClient";

export class SnapshotsService {
  async getSnapshots(search, includeSummary = false) {
    const response = await apiClient.getWithCache("api/snapshots/", {
      params: search,
    });
    return response.data;
  }

  async getSnapshotsForCatCode(catCodeString, search) {
    const response = await apiClient.getWithCache(
      "api/snapshots/catCode/" + catCodeString,
      {
        params: search,
      }
    );
    return response.data;
  }

  async getSnapshotsHistory(
    catCodeString,
    {
      includeListings = false,
      includeSoldItems = false,
      filter,
      timeFrameMonths,
    } = {}
  ) {
    const response = await apiClient.getWithCache(
      `api/snapshots/catCode/history/${catCodeString}`,
      {
        params: {
          includeListings,
          includeSoldItems,
          filter,
          timeFrameMonths,
        },
      }
    );
    return response.data;
  }

  async getSnapshot(id, { filter } = {}) {
    const response = await apiClient.getWithCache("api/snapshots/" + id, {
      params: {
        includeListings: true,
        includeSoldItems: true,
        filter,
      },
    });
    return response.data;
  }

  async getLatestSnapshotForCatCode(catCodeString, { filter } = {}) {
    const response = await apiClient.getWithCache(
      "api/snapshots/latestForCatCode/" + catCodeString,
      {
        params: {
          includeListings: true,
          includeSoldItems: true,
          filter,
        },
      }
    );
    return response.data;
  }

  async getLatestSnapshotForMarketplace(
    marketplaceID,
    catCodeString,
    { filter } = {}
  ) {
    const response = await apiClient.getWithCache(
      "api/snapshots/latestForMarketplace/" +
        marketplaceID +
        "/" +
        catCodeString,
      {
        params: {
          includeListings: true,
          includeSoldItems: true,
          filter,
        },
      }
    );
    return response.data;
  }

  async getSnapshotApiCalls(id, search) {
    const response = await apiClient.get(`api/snapshots/${id}/apiCalls`, {
      params: search,
    });
    return response.data;
  }

  async getSnapshotApiCall(id, apiCallId) {
    const response = await apiClient.get(
      `api/snapshots/${id}/apiCalls/${apiCallId}`
    );
    return response.data;
  }

  async startScan(catCodeString) {
    const response = await apiClient.get(
      "api/snapshots/startScan/" + catCodeString
    );
    return response.data;
  }

  async startScanForMarketplace(marketplaceID, catCodeString) {
    const response = await apiClient.post("api/snapshots/startScan", {
      marketplaceID,
      catCodeString,
    });
    return response.data;
  }

  async anyScansInProgress(partId) {
    const response = await apiClient.get(
      "api/snapshots/anyInProgress/" + partId
    );
    return response.data;
  }

  async deleteSnapshot(id) {
    const response = await apiClient.delete("api/snapshots/delete/" + id);
    apiClient.clearCache("api/snapshots");
    return response.data;
  }

  async recalculateSnapshot(id) {
    const response = await apiClient.post("api/snapshots/recalculate/" + id);
    apiClient.clearCache("api/snapshots/" + id);
    return response.data;
  }

  clearCache() {
    apiClient.clearCache("api/snapshots");
  }
}
